import { action, computed, makeObservable, observable } from 'mobx';
import { WindowController } from './WindowController';

/** Сущность для открытия одиночного окна */
export class SingleWindow<D extends Record<string, any> = {}> {
  @observable private _window?: WindowController<D> = undefined;

  constructor() {
    makeObservable<SingleWindow<D>>(this);
  }

  @computed get window() {
    return this._window;
  }

  @action open = (data: D) => {
    this._window = new WindowController<D>({ data, defaultVisible: true });
  };

  @action close = () => {
    this._window = undefined;
  };
}
